import api from '@cannect/services/api'
import type { TPublicScreeningModule, TScreeningBindCpf, TScreeningCreate, TScreeningNext } from './types'

export const SCREENING_TOKEN_KEY = '@CANNECT_SCREENING_TOKEN'

export const buildScreeningDestinationPath = (next: TScreeningNext, token: string, destination = next.destination) => {
  if (destination === 'instant') return `/consulta-na-hora?screening=${token}`
  const params = new URLSearchParams()
  params.set('filter_by', next.filter_by || 'pathology')
  ;(next.filter_names || []).forEach((name) => params.append('filter_by_name', name))
  if (next.is_minor) params.set('attends_children', 'true')
  params.set('screening', token)
  return `/agendamento?${params.toString()}`
}

export const createScreeningSession = async (hero_slug: string, module_slug?: string) => {
  const { data } = await api.post<{
    success: boolean
    data: TScreeningCreate
    message?: string
  }>('/screening/sessions', { hero_slug, module_slug })
  return data
}

export const getPublicScreeningModules = async () => {
  const { data } = await api.get<{ success: boolean; data: { modules: TPublicScreeningModule[] } }>(
    '/screening/modules'
  )
  return data.data.modules
}

export const getScreeningNext = async (token: string) => {
  const { data } = await api.get<{ success: boolean; data: TScreeningNext }>(`/screening/sessions/${token}/next`)
  return data.data
}

export const postScreeningContact = async (token: string, payload: Record<string, unknown>) => {
  const { data } = await api.post<{ success: boolean; data: TScreeningNext }>(
    `/screening/sessions/${token}/contact`,
    payload
  )
  return data.data
}

export const postScreeningAnswer = async (token: string, payload: { key: string; value: unknown }) => {
  const { data } = await api.post<{ success: boolean; data: TScreeningNext }>(
    `/screening/sessions/${token}/answers`,
    payload
  )
  return data.data
}

export const postScreeningBack = async (token: string) => {
  const { data } = await api.post<{ success: boolean; data: TScreeningNext }>(
    `/screening/sessions/${token}/back`
  )
  return data.data
}

export const bindScreeningCpf = async (token: string, cpf: string) => {
  const { data } = await api.post<{ success: boolean; data: TScreeningBindCpf }>(
    `/screening/sessions/${token}/bind-cpf`,
    { cpf }
  )
  return data.data
}
